import Emitter from "./Emitter";

export default class RealityCheckCloseGame extends Emitter {
    constructor(gb) {
        super(gb);
    }

    SBTECH_handler() {
        if (this.gb.utils.isIframe === true) {
            this.emitTop(JSON.stringify({"event": "casino-reality-check","action": "stop","game_provider":"oryx"}));
        } else {
            this.gb.emitters.emit.web.closeGame();
        }

    }

    _default() {
        this.gb.emitters.emit.web.closeGame();
    }
}
